

// import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { Link, useNavigate } from "react-router-dom";
// const getAuthToken = () => {
//   const userData = sessionStorage.getItem("userData");
//   if (!userData) return "";
//   try {
//     const parsed = JSON.parse(userData);
//     return parsed.token || "";
//   } catch {
//     return "";
//   }
// };
// const ProductModal = ({ show, onHide, product, onCartSuccess }) => {
//   const [quantity, setQuantity] = useState(1);
// const navigate=useNavigate();
//   const incrementQuantity = () => setQuantity((q) => q + 1);
//   const decrementQuantity = () => setQuantity((q) => Math.max(1, q - 1));

//   const handleBackdropClick = (e) => {
//     if (e.target === e.currentTarget) {
//       onHide();
//     }
//   };

// const handleAddToCart = async (isBuyNow = false) => {
//   const token = getAuthToken();

//   // 🚫 If not logged in
//   if (!token) {
   
//     sessionStorage.setItem("redirectAfterLogin", isBuyNow ? "/proceedcheckout" : window.location.pathname);
//     return;
//   }

//   try {
//     const res = await axios.post(
//       "https://vantara.datacubeglobal.com/api/cart",
//       {
//         product_id: product?.id || product?.product_id,
//         quantity: quantity,
//         options: "",
        
//       },
//       {
//         headers: { Authorization: `Bearer ${token}` },
//       }
//     );

//     if (res.data.status === "success") {
//       onHide();

//       Swal.fire({
//         toast: true,
//         icon: "success",
//         title: "Added to Cart successfully",
//         position: "top-end",
//         showConfirmButton: false,
//         timer: 800,
//         timerProgressBar: true,
//       }).then(() => {
//         if (onCartSuccess) onCartSuccess(product);

//         // ✅ If Buy Now, go to checkout
//         if (isBuyNow) {
//           navigate("/proceedcheckout");
//         }
//       });
//     } else {
//       Swal.fire({
//         toast: true,
//         icon: "info",
//         title: res.data.message || "Unable to add to cart",
//         position: "top-end",
//         showConfirmButton: false,
//         timer: 2000,
//         timerProgressBar: true,
//       });
//     }
//   } catch (error) {
//     console.error("Error adding to cart:", error);
//     Swal.fire({
//       toast: true,
//       icon: "error",
//       title: "Something went wrong!",
//       position: "top-end",
//       showConfirmButton: false,
//       timer: 2000,
//       timerProgressBar: true,
//     });
//   }
// };

// const discountPercentage =
//   product?.mrp && product?.special_price
//     ? Math.round(((product.mrp - product.special_price) / product.mrp) * 100)
//     : 0;


//   return (
//     <div
//       className={`modal ${show ? "d-block" : "d-none"}`}
//       style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//       onClick={handleBackdropClick}
//     >
//       <div className="modal-dialog modal-dialog-centered">
//         <div className="modal-content border-0 rounded-4 shadow">
//           {/* Close Button */}
//           <button
//             type="button"
//             className="btn position-absolute top-0 end-0 m-3 fs-4"
//             onClick={onHide}
//             style={{ background: "none", border: "none", zIndex: 1 }}
//           >
//             &times;
//           </button>

//        <div className="modal-body p-4" style={{ paddingRight: '20px' }}>
      
//             {/* <div className="d-flex align-items-start mb-3">
//               <img
//                 src={
//                   product?.image || product?.images?.[0] ||
//                   "https://modavenextjs.vercel.app/images/products/womens/women-19.jpg"
//                 }
//                 alt={product?.name}
//                 style={{
//                   width: "60px",
//                   height: "80px",
//                   objectFit: "cover",
//                   borderRadius: "6px",
//                 }}
//               />
            
//         <div className="ms-3 flex-grow-1" style={{ maxWidth: 'calc(100% - 30px)' }}>
//   <h6 className="mb-1" style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
//     {product?.name || "Product Name"}
//   </h6>
//   <div className="d-flex align-items-center gap-2">
//     <span className="fw-bold fs-5">
//       Rs.{product?.price.toFixed(2)}
//     </span>
//     {product?.originalPrice > product?.price && (
//       <span className="text-muted text-decoration-line-through">
//         Rs.{product?.originalPrice.toFixed(2)}
//       </span>
//     )}
//   </div>
// </div>
//             </div> */}
//             <div className="d-flex align-items-start mb-3">
//   <img
//     src={
//       product?.image || product?.images?.[0] ||
//       "https://modavenextjs.vercel.app/images/products/womens/women-19.jpg"
//     }
//     alt={product?.name}
//     style={{
//       width: "60px",
//       height: "80px",
//       objectFit: "cover",
//       borderRadius: "6px",
//       flexShrink: 0 // Prevent image from shrinking
//     }}
//   />

//   <div className="ms-3 flex-grow-1" style={{ minWidth: 0 }}> {/* Important: minWidth: 0 allows text wrapping in flex containers */}
//     <h6 
//       className="mb-1" 
//       style={{ 
//         wordBreak: 'break-word', 
//         overflowWrap: 'break-word',
//         whiteSpace: 'normal', // Ensure text wraps
//         lineHeight: '1.4' // Better readability for multi-line text
//       }}
//     >
//       {product?.name || "Product Name"}
//     </h6>
//     <div className="d-flex align-items-center gap-2">
//       <span className="fw-bold fs-5">
//         Rs.{product?.price?.toFixed(2)}
//       </span>
//       {product?.originalPrice > product?.price && (
//         <span className="text-muted text-decoration-line-through">
//           Rs.{product?.originalPrice?.toFixed(2)}
//         </span>
//       )}
//     </div>
//   </div>
// </div>

//             <div className="mb-4">
//               <label className="form-label small">Quantity:</label>
//               <div
//                 className="d-flex align-items-center rounded-pill border px-2"
//                 style={{ width: "140px" }}
//               >
//                 <button
//                   className="btn btn-sm"
//                   onClick={decrementQuantity}
//                   style={{ fontSize: "18px" }}
//                 >
//                   −
//                 </button>
//                 <span className="flex-grow-1 text-center">{quantity}</span>
//                 <button
//                   className="btn btn-sm"
//                   onClick={incrementQuantity}
//                   style={{ fontSize: "18px" }}
//                 >
//                   +
//                 </button>
//               </div>
//             </div>

//            <div className="d-flex flex-column gap-2">
//   {getAuthToken() ? (
//     <>
//       <div className="d-flex align-items-center gap-2 mb-3">
//         <button
//           className="btn flex-grow-1 rounded-pill py-3"
//          onClick={() => handleAddToCart(false)}
//           style={{
//             backgroundColor: "#7c0046",
//             color: "#fff",
//           }}
//         >
//           ADD TO CART  Rs.{(product?.price * quantity).toFixed(2)}
//         </button>
//       </div>

//       <button
//          onClick={() => handleAddToCart(true)}
//         className="btn w-100 rounded-pill py-3"
//         style={{
//           backgroundColor: "#124f14",
//           color: "#fff",
//         }}
//       >
//         BUY IT NOW
//       </button>
//     </>
//   ) : (
//     <p className="text-center text-muted">
//       Please log in to add products to your cart.<Link to="/login"> Login</Link>
//     </p>
//   )}
// </div>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductModal;


import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";

const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};

const ProductModal = ({ show, onHide, product, onCartSuccess }) => {
  const [quantity, setQuantity] = useState(1);
  const navigate = useNavigate();

  const incrementQuantity = () => setQuantity((q) => q + 1);
  const decrementQuantity = () => setQuantity((q) => Math.max(1, q - 1));

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onHide();
  };

  const calculateDiscountPercentage = (mrp, specialPrice) => {
    if (mrp <= 0) return 0; 
    return ((mrp - specialPrice) / mrp) * 100;
  };

  const handleAddToCart = async (isBuyNow = false) => {
    const token = getAuthToken();

    if (!token) {
      sessionStorage.setItem(
        "redirectAfterLogin",
        isBuyNow ? "/proceedcheckout" : window.location.pathname
      );
      return;
    }

    try {
      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/cart",
        {
          product_id: product?.id || product?.product_id,
          quantity,
          options: "",
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.status === "success") {
        onHide();
        Swal.fire({
          toast: true,
          icon: "success",
          title: "Added to Cart successfully",
          position: "top-end",
          showConfirmButton: false,
          timer: 800,
        }).then(() => {
          if (onCartSuccess) onCartSuccess(product);
          if (isBuyNow) navigate("/proceedcheckout");
        });
      } else {
        Swal.fire({
          toast: true,
          icon: "info",
          title: res.data.message || "Unable to add to cart",
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      Swal.fire({
        toast: true,
        icon: "error",
        title: "Something went wrong!",
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };



const discountPercentage =
  product?.originalPrice && product?.price
    ? Math.round(calculateDiscountPercentage(product.originalPrice, product.price))
    : 0;



  return (
    <div
      style={{
        display: show ? "flex" : "none",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1050,
      }}
      onClick={handleBackdropClick}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
          width: "90%",
          maxWidth: "420px",
          position: "relative",
        }}
      >
        {/* Close Button */}
        <button
          onClick={onHide}
          style={{
            position: "absolute",
            top: "10px",
            right: "15px",
            fontSize: "24px",
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#333",
          }}
        >
          &times;
        </button>

        <div style={{ padding: "24px" }}>
         
          <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "20px" }}>
            <img
              src={
                product?.image ||
                product?.images?.[0] ||
                "https://modavenextjs.vercel.app/images/products/womens/women-19.jpg"
              }
              alt={product?.name}
              style={{
                width: "70px",
                height: "90px",
                objectFit: "cover",
                borderRadius: "8px",
                flexShrink: 0,
              }}
            />
            <div style={{ marginLeft: "12px", flexGrow: 1, minWidth: 0 }}>
              <h6
                style={{
                  marginBottom: "6px",
                  fontSize: "16px",
                  fontWeight: 600,
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  lineHeight: "1.4",
                }}
              >
                {product?.name || "Product Name"}
              </h6>
             <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
  <span style={{ fontSize: "18px", color: "black", fontWeight: "600" }}>
    Rs.{product?.price?.toFixed(2)}
  </span>

  {product?.originalPrice > product?.price && (
    <span
      style={{
        color: "#888",
        textDecoration: "line-through",
        fontSize: "14px",
      }}
    >
      Rs.{product?.originalPrice?.toFixed(2)}
    </span>
  )}

  {discountPercentage > 0 && (
    <span
      style={{
        backgroundColor: "#ff4d4d",
        color: "white",
        fontWeight: "600",
        fontSize: "12px",
        borderRadius: "12px",
        padding: "3px 8px",
        marginLeft: "4px",
      }}
    >
      {discountPercentage}% OFF
    </span>
  )}
</div>


            </div>
          </div>

          {/* Quantity */}
          <div style={{ marginBottom: "24px", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <label
              style={{
                fontSize: "14px",
                color: "#555",
                display: "block",
                marginBottom: "6px",
                textAlign: "center",
              }}
            >
              Quantity:
            </label>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #ccc",
                borderRadius: "25px",
                width: "140px",
                padding: "4px 8px",
                justifyContent: "center",
              }}
            >
              <button
                onClick={decrementQuantity}
                style={{
                  fontSize: "18px",
                  border: "none",
                  background: "none",
                  cursor: "pointer",
                  width: "30px",
                }}
              >
                −
              </button>
              <span style={{ flex: 1, textAlign: "center" }}>{quantity}</span>
              <button
                onClick={incrementQuantity}
                style={{
                  fontSize: "18px",
                  border: "none",
                  background: "none",
                  cursor: "pointer",
                  width: "30px",
                }}
              >
                +
              </button>
            </div>
          </div>

          {/* Buttons */}
          {getAuthToken() ? (
            <>
              <button
                onClick={() => handleAddToCart(false)}
                style={{
                  backgroundColor: "#7c0046",
                  color: "#fff",
                  border: "none",
                  borderRadius: "30px",
                  padding: "12px 16px",
                  fontWeight: "500",
                  width: "100%",
                  marginBottom: "10px",
                  cursor: "pointer",
                }}
              >
                ADD TO CART &nbsp;Rs.{(product?.price * quantity).toFixed(2)}
              </button>

              <button
                onClick={() => handleAddToCart(true)}
                style={{
                  backgroundColor: "#124f14",
                  color: "#fff",
                  border: "none",
                  borderRadius: "30px",
                  padding: "12px 16px",
                  fontWeight: "500",
                  width: "100%",
                  cursor: "pointer",
                }}
              >
                BUY IT NOW
              </button>
            </>
          ) : (
            <p style={{ textAlign: "center", color: "#777", fontSize: "14px" }}>
              Please log in to add products to your cart.&nbsp;
              <Link to="/login" style={{ color: "#7c0046", textDecoration: "none" }}>
                Login
              </Link>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductModal;